import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="select-none font-heading text-7xl font-black text-background-300 md:text-9xl">
        404
      </h1>
      <h2 className="mt-4 font-heading text-xl font-semibold text-foreground-900 md:text-2xl">
        页面走丢了
      </h2>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你要找的页面暂时不存在，路径
        <span className="mx-1 rounded bg-background-200 px-1.5 py-0.5 font-mono text-foreground-600">
          {location.pathname}
        </span>
        没有对应的内容。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
        >
          去搜索小说
        </Link>
      </div>
    </div>
  );
}